import React, { useState } from "react";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { Label } from "@progress/kendo-react-labels";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useActiveBranches } from "services/branchService";
import SubmitButton from "components/common/SubmitButton";

const EditForm = (props) => {
  const ADD_NEW = props.type === "add";
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const { data: branches, loading: branchesLoading } = useActiveBranches();

  const validateForm = (values) => {
    const errors = {};
    if (!values.teamName) {
      errors.teamName = "Team Name is required.";
    }
    if (!values.branch) {
      errors.branch = "Branch is required.";
    }
    return errors;
  };

  const handleFormSubmit = async (formData) => {
    setIsSubmitting(true);
    try {
      const formDataWithBranchId = {
        teamName: formData.teamName,
        teamID: formData.teamID,
        branchId: formData?.branch?.branchId,
        branchName: formData?.branch?.branchName,
        active: ADD_NEW ? true : formData.active,
      };
      await props.onSubmit(formDataWithBranchId);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div>
        <Form
          onSubmit={handleFormSubmit}
          validator={validateForm}
          initialValues={
            ADD_NEW
              ? null
              : {
                  ...props.item,
                  branch: {
                    branchId: props?.item?.branchId,
                    branchName: props?.item?.branchName,
                  },
                }
          }
          render={(formRenderProps) => (
            <>
              <FormElement style={{ maxWidth: 1000 }}>
                <fieldset className="k-form-fieldset p-3 ps-4">
                  <div className="mb-3">
                    <Label className="label mt-1 mb-2 w-100">
                      Team Name&nbsp;
                    </Label>
                    <Field
                      name={"teamName"}
                      placeholder="Enter Team Name"
                      component={Input}
                    />
                    {submitAttempted && formRenderProps.errors?.teamName && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.teamName}</i>
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <Label className="label mt-1 mb-2 w-100">
                      Branch Name&nbsp;
                    </Label>

                    <Field
                      style={{ width: "300px" }}
                      data={branches || []}
                      name={"branch"}
                      iconClassName="wa"
                      textField={"branchName"}
                      placeholder={
                        branchesLoading
                          ? "Loading branches..."
                          : "Select Branch"
                      }
                      component={ComboBox}
                      disabled={branchesLoading}
                    />
                    {submitAttempted && formRenderProps.errors?.branch && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.branch}</i>
                      </div>
                    )}
                  </div>

                  {!ADD_NEW && (
                    <div>
                      <Field
                        style={{
                          marginRight: "10px",
                          width: "20px",
                        }}
                        name={"active"}
                        component={Checkbox}
                        label={"Active"}
                      />
                    </div>
                  )}
                </fieldset>
                <div className="dialog-footer">
                  <Button
                    className="bgBtnSecondary common-btn me-2"
                    onClick={props.cancelEdit}
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    onClick={(e) => {
                      e.preventDefault();
                      formRenderProps.onSubmit();
                      setSubmitAttempted(true);
                    }}
                    className="me-3"
                    disabled={!ADD_NEW && !formRenderProps.modified}
                    isLoading={isSubmitting}
                  >
                    {ADD_NEW ? "Save" : "Update"}
                  </SubmitButton>
                </div>
              </FormElement>
            </>
          )}
        />
      </div>
    </>
  );
};

export default EditForm;
